import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/api";
import {
  FAQS as STATIC_FAQS,
  PRODUCTS as STATIC_PRODUCTS,
  TESTIMONIALS as STATIC_TESTIMONIALS,
  CASE_STUDIES as STATIC_CASE_STUDIES,
} from "../data/content";

const SiteContentContext = createContext(null);
export const useSiteContent = () => useContext(SiteContentContext);

// Static fallbacks (mapped to the DB {data} shape) so the site never breaks
// if the content API is briefly unavailable.
const FALLBACK = {
  faqs: STATIC_FAQS.map((d) => ({ id: d.q, data: d })),
  products: STATIC_PRODUCTS.items.map((d) => ({ id: d.name, data: { ...d, icon: d.name.includes("Retention") ? "Users" : "Receipt" } })),
  testimonials: STATIC_TESTIMONIALS.items.map((d, i) => ({ id: String(i), data: d })),
  case_studies: STATIC_CASE_STUDIES.items.map((d) => ({ id: d.title, data: { ...d, draft: true } })),
};

const DEFAULT_SECTIONS = {
  marquee: true, philosophy: true, services: true, products: true, why: true,
  process: true, tech: true, "case-studies": true, testimonials: true,
  founder: true, faq: true,
};

export function SiteContentProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    faqs: [],
    products: [],
    testimonials: [],
    case_studies: [],
    settings: { scheduler_url: "", sections: DEFAULT_SECTIONS },
  });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/content");
        if (!active) return;
        setState({
          loading: false,
          faqs: data.faqs?.length ? data.faqs : FALLBACK.faqs,
          products: data.products?.length ? data.products : FALLBACK.products,
          testimonials: data.testimonials?.length ? data.testimonials : FALLBACK.testimonials,
          case_studies: data.case_studies?.length ? data.case_studies : FALLBACK.case_studies,
          settings: {
            scheduler_url: data.settings?.scheduler_url || "",
            sections: { ...DEFAULT_SECTIONS, ...(data.settings?.sections || {}) },
          },
        });
      } catch {
        if (!active) return;
        setState((s) => ({
          ...s,
          loading: false,
          faqs: FALLBACK.faqs,
          products: FALLBACK.products,
          testimonials: FALLBACK.testimonials,
          case_studies: FALLBACK.case_studies,
        }));
      }
    })();
    return () => { active = false; };
  }, []);

  return <SiteContentContext.Provider value={state}>{children}</SiteContentContext.Provider>;
}
